import { createWebHistory, createRouter } from 'vue-router';
import LoginPage from '@/pages/login/LoginPage.vue';
import PasswordResetPage from '@/pages/passwordReset/PasswordResetPage.vue';
import AddPhotoPage from '@/pages/addMedia/AddPhotoPage.vue';
import AddVideoPage from '@/pages/addMedia/AddVideoPage.vue';
import UserPanelPage from '@/pages/userPanel/UserPanelPage.vue';
import BookingsCalendar from '@/pages/bookings/components/BookingsCalendar.vue';
import DashboardEventsListPage from '@/pages/dashboardEvents/dashboardEventsList/DashboardEventsListPage.vue';
import DashboardEventsSinglePage from '@/pages/dashboardEvents/dashboardEventsSingle/DashboardEventsSinglePage.vue';
import routerGuardService from '@/services/routerGuard.service';

const routes = [
  {
    path: '/',
    name: 'addPhoto',
    component: AddPhotoPage,
  },
  {
    path: '/add-video',
    name: 'addVideo',
    component: AddVideoPage,
    meta: {
      requiresAuth: true,
      allowedRoles: ['administrator'],
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/reset-password',
    name: 'PasswordReset',
    component: PasswordResetPage,
    beforeEnter: routerGuardService.validatePasswordReset,
  },
  {
    path: '/userPanel',
    name: 'userPanel',
    component: UserPanelPage,
    props: (route) => ({ defaultTab: route.query.tab }),
    meta: {
      requiresAuth: true,
    },
    beforeEnter: routerGuardService.handleTabSwitch,
  },
  {
    path: '/my-events',
    name: 'dashboardEventsList',
    component: DashboardEventsListPage,
    meta: {
      requiresAuth: true,
      allowedRoles: ['administrator', 'organizer', 'sponsor', 'photographer'],
    },
  },
  {
    path: '/my-events/:eventId',
    name: 'dashboardEventsSingle',
    component: DashboardEventsSinglePage,
    beforeEnter: routerGuardService.validateDashboardEventsSingle,
    meta: {
      requiresAuth: true,
      allowedRoles: ['administrator', 'organizer', 'sponsor'],
    },
  },
  {
    path: '/bookings',
    name: 'user-bookings',
    redirect: { name: 'userPanel', query: { tab: 'bookings' } },
    meta: {
      requiresAuth: true,
      allowedRoles: ['organizer', 'photographer'],
    },
  },
  {
    path: '/bookings-calendar',
    name: 'bookings-calendar',
    component: BookingsCalendar,
    meta: {
      requiresAuth: true,
      allowedRoles: ['photographer'],
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: AddPhotoPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user');
  const user = loggedIn ? JSON.parse(loggedIn) : null;

  if (to.meta.requiresAuth && !user) {
    return next({ name: 'Login' });
  }

  if (to.meta.allowedRoles && user) {
    const userRole = user.role;
    if (!to.meta.allowedRoles.includes(userRole)) {
      return next({ name: 'addPhoto' });
    }
  }

  if (to.name === 'userPanel' && to.query.tab === 'settings') {
    const allowedForSettings = ['photographer'];
    if (!allowedForSettings.includes(user?.role)) {
      return next({ name: 'addPhoto' });
    }
  }

  next();
});
export default router;
